import React from 'react';
import { Navigate } from 'react-router-dom';
import { ListingRoute } from '../../../models';
import BusinessInfo from '../../../common-pages/BusinessInfo';
import ListingOptions from '../../../common-pages/ListingOptions';
import MediaBuying from '../../../common-pages/MediaBuying';
import Checkout from '../../../common-pages/Checkout';
import { TeaserPreview } from 'router/subrouters/ListingCreationWizard/common-pages/TeaserPreview';
import { StatementOfInformation } from 'router/subrouters/ListingCreationWizard/common-pages/StatementOfInformation';

export default [
  {
    path: 'business-info',
    element: BusinessInfo,
    labelId: 'addBusinessInfoLabelId',
  },
  {
    path: 'statement-of-information',
    labelId: 'statementOfInformationLabelId',
    element: StatementOfInformation,
  },
  {
    path: 'listing-options',
    element: ListingOptions,
    labelId: 'listingOptionsLabelId',
  },
  {
    path: 'media-package',
    element: MediaBuying,
    labelId: 'mediaPackageLabelId',
  },
  {
    path: 'checkout',
    element: Checkout,
    labelId: 'checkoutLabelId',
  },
  {
    path: 'teaser-preview',
    element: TeaserPreview,
  },
  { index: true, element: <Navigate to="business-info" replace /> },
] as Array<ListingRoute>;
